import {
    AppBar,
    Container,
    Grid,
    IconButton,
    Toolbar,
} from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";

function LuicdAppBar() {
    return (
        <AppBar position="static" color="primary">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Grid
                        container
                        spacing={0}
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Grid item xs="auto">
                            <Link href="/">
                                <Logo style={{ height: "50" }} />
                            </Link>
                        </Grid>

                        <Grid item>
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default LuicdAppBar;
